<template>
  <yd-dialog :title="''" :visible.sync="visible" width="400px" center>
    <div class="flex flex-justify-center" id="qrcodeBox">
      <VueQr :text="codeUrl" :size="340" />
    </div>
    <slot name="content">
      <el-row>
        <el-col :align="'center'">
          <el-button type="primary" style="width: 300px" @click="handleDownload" :loading="loading">
            下载二维码
          </el-button>
        </el-col>
      </el-row>
    </slot>

    <template #footer>
      <el-button @click="handleClose">关 闭</el-button>
    </template>
  </yd-dialog>
</template>

<script >
import { ref, computed, watch } from '@vue/composition-api';
import { useDownloadCode } from '@/hooks';
import VueQr from 'vue-qr';
const __sfc_main = {};
__sfc_main.props = {
  value: {
    type: Boolean,
    default: false
  },
  codeObj: {
    type: Object,
    default: () => {}
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emits = __ctx.emit;
  const visible = computed({
    get() {
      return props.value;
    },
    set(val) {
      emits('input', val);
    }
  });
  const codeUrl = ref('');
  const codeName = ref('');
  watch(() => props.codeObj, v => {
    const {
      url,
      name
    } = v || {};
    codeUrl.value = url;
    codeName.value = name;
  }, {
    deep: true
  });
  const handleClose = () => {
    emits('input', false);
  };

  // 下载推荐码
  const {
    loading,
    downloadCode
  } = useDownloadCode('qrcodeBox');
  const handleDownload = () => {
    const fileName = `${codeName.value}.jpg`;
    downloadCode(fileName);
  };
  return {
    visible,
    codeUrl,
    handleClose,
    loading,
    handleDownload
  };
};
__sfc_main.components = Object.assign({
  VueQr
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped></style>
